import * as React from "react";
import { useState, useEffect, useCallback } from "react";
import { useFormikContext, useField } from "formik";
import { PasswordInput } from "security-app/components/common";
function FormikPasswordInput({ field, label, action, placeholder, help, required, disabled, hasPassword }) {
  const [_f, { touched, error }] = useField({ name: field.name });
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [localValue, setLocalValue] = useState(
    field.value.keep_value || field.value.is_set || field.value.set_value
  );
  useEffect(() => {
    if (field.value.is_set) {
      setFieldValue(field.name, { keep_value: true });
    }
  }, [field.name, field.value, setFieldValue]);
  const updateValue = (e) => {
    const { target } = e;
    setLocalValue(target.value);
    setFieldTouched(target.name, true);
    field.onChange({
      ...e,
      target: {
        ...target,
        name: field.name,
        value: typeof target.value === "boolean" ? { keep_value: target.value } : { set_value: target.value }
      }
    });
  };
  const onResetValue = useCallback(() => {
    setFieldValue(field.name, { set_value: "" });
    setFieldTouched(field.name, true);
  }, [field.name, setFieldTouched, setFieldValue]);
  const onCancelResetValue = useCallback(() => {
    setFieldValue(field.name, { keep_value: hasPassword });
  }, [setFieldValue, field.name, hasPassword]);
  return /* @__PURE__ */ React.createElement(
    PasswordInput,
    {
      name: field.name,
      label,
      action,
      placeholder,
      value: localValue,
      help: touched && !!error ? null : help,
      error: touched && !!error ? error : "",
      onChange: updateValue,
      onBlur: updateValue,
      onResetPassword: onResetValue,
      onCancelReset: onCancelResetValue,
      hasPassword,
      required,
      disabled
    }
  );
}
export default FormikPasswordInput;
